exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".textarea-custom-for-gift {\n  max-height: 52px;\n}\n.textarea-custom-for-gift textarea {\n    border: none;\n    min-height: 55px;\n    margin-top: 0;\n}\n", ""]);

// exports
